import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Typography, message, Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { activateAccount } from './verify.service';

const { Title, Text } = Typography;

const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 4rem);
  padding: 2rem;
  align-items: center;
  justify-content: center;
  background-color: #f4f6fb;
  flex-direction: column;
`;

const ActivationSection = styled.div`
  max-width: 400px;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const ActivateAccount: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleActivation = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          throw new Error('Invalid activation link.');
        }

        await activateAccount();
        message.success('Account activated successfully! Redirecting to homepage...');

        setTimeout(() => {
          navigate('/');
        }, 2000);
      } catch (err: any) {
        setError(err.response?.data?.message || 'Failed to activate account.');
        message.error(err.response?.data?.message || 'Failed to activate account.');
      } finally {
        setLoading(false);
      }
    };

    handleActivation();
  }, [searchParams, navigate]);

  return (
    <Container>
      <ActivationSection>
        {loading ? (
          <Spin size="large" />
        ) : error ? (
          <Text type="danger">{error}</Text>
        ) : (
          <>
            <Title level={2}>Account Activated</Title>
            <Text>Your account has been successfully activated. Redirecting...</Text>
          </>
        )}
      </ActivationSection>
    </Container>
  );
};

export default ActivateAccount;
